import React, { useEffect } from 'react';
//infinity-observer
import { useInView } from 'react-intersection-observer';
//hooks
import useReservHook from 'src/webapp/hooks/reserv/reserv.hook';
//CompWrapper
import Section from 'src/webapp/views/wrapper/Section';
import Container from 'src/webapp/views/wrapper/Container';
import FixedPanel from 'src/webapp/views/wrapper/FixedPanel';
import FlickPanel from 'src/webapp/views/wrapper/FlickPanel';
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
//Comp
import Menu from 'src/webapp/views/component/Menu';//메뉴
import Titlebar from 'src/webapp/views/component/Titlebar';//상단타이틀
import Search from './Search';//회원검색
import List from './List';//회원목록
import InViewData from 'src/webapp/views/component/data/InViewData';//데이터로드확인

export default function CalcMemberReservList() {
    //hook
    const {pageRef//무한로딩페이지DOM
        , searchRef//검색어DOM
        , scrollRef//elementScroll관리Ref
        , memberReservList//예약리스트데이터
        , memberReservListAPI//예약리스트API
    } = useReservHook();
    useEffect(() => {
        memberReservListAPI(0, 3);//예약리스트API
    }, []);
    //infinityObserver
    const [ inViewRef, inView ] = useInView({ threshold: .5 });
    useEffect(() => {
        if (inView && (pageRef.current != null)) { memberReservListAPI(1, 3); }//예약리스트API
    }, [inView]);

    return ( 
        <Section>
            <Menu />{/* 메뉴 */}
            <Container>
                <FixedPanel>
                    <Titlebar title={`멤버스 결제`} cnt={`${memberReservList[0]?.TOT_CNT ?? 0}건`} dept={[{label:'정산 관리'}, {label:'멤버스 결제'}]} />{/* 상단타이틀 */}
                </FixedPanel>
                <FixedPanel>
                    <Search search={searchRef} onSearch={memberReservListAPI} />
                </FixedPanel>
                <FlickPanel>
                    <Element tag={`div`} className="fullHeight">
                    <List list={memberReservList} scrollRef={scrollRef} />
                        {memberReservList.length > 0 && pageRef.current != null ? <div ref={inViewRef}><InViewData inView={true} /></div>
                        : memberReservList.length > 0 && pageRef.current === null ? <InViewData readAll={true} /> 
                        : null}
                    </Element>
                </FlickPanel>
            </Container>
        </Section>
    );
}